module.exports = __webpack_public_path__ + "static/21-153b951eedb4eefdc63d198ae3e7a82a.jpg";